const standardETLNotification = ({ title, appearance, message, onClose, dismissIn }) => {
  const service = window.datashop.app.module('AlertService');
  service.add({
    title: title,
    appearance: appearance,
    message: message,
    onClose: onClose,
    autoDismiss: true
  });
  return null;
};

export default standardETLNotification;
